import { render } from "./OrderItem.vue?vue&type=template&id=a9c68454&scoped=true"
import script from "./OrderItem.vue?vue&type=script&lang=js"
export * from "./OrderItem.vue?vue&type=script&lang=js"

import "./OrderItem.vue?vue&type=style&index=0&id=a9c68454&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9c68454"]])

export default __exports__